class YoutubeCookies {
    static init() {
        if (document.querySelector('.btn-video')) {
            document.querySelector('.btn-video').addEventListener('click', function () {
                if (document.cookie.indexOf('youtube=true') >= 0) {
                    document.querySelector('.yt-displayer-box').style.display = "none";
                }
            })
        }
    }
}

export default YoutubeCookies;


// WEBPACK FOOTER //
// ./src/scripts/components/youtubeCookies.js